'use strict';

exports = module.exports;
exports.multicodec = '/ipfs/id/1.0.0';
exports.listener = require('./listener');
exports.dialer = require('./dialer');
exports.message = require('./message');